var THREE         = require("three");

var Camera3DView = function (cameraModel, editorView) {

    var self = this;
    this.model = cameraModel;
    this.editorView = editorView;

    this.perspectiveCamera = new THREE.PerspectiveCamera( 
        this.model.fov , 
        this.editorView.canvasWidth / this.editorView.canvasHeight,
        this.model.near, 
        this.model.far 
    );

    this.perspectiveCamera.up.copy( this.model.up );


    this.camFac = this.model.fov/2;

    this.orthographicCamera = new THREE.OrthographicCamera( 
       -this.editorView.canvasWidth  /  this.camFac, 
        this.editorView.canvasWidth  /  this.camFac, 
        this.editorView.canvasHeight /  this.camFac, 
       -this.editorView.canvasHeight /  this.camFac, 
       this.model.near, 
       this.model.far
    );

    this.orthographicCamera.up.copy( this.model.up );


    this.viewCamera = this.perspectiveCamera;


    this.model.perspectiveCameraPosition.onChange("moveAllCameras", function(newval){

        self.perspectiveCamera.position.copy(newval);
        self.perspectiveCamera.lookAt(self.model.cameraTarget().toThreejs());

        //self.orthographicCamera.position.copy(newval);
        //self.orthographicCamera.lookAt(self.model.cameraTarget());

         self.editorView.render();
    });

    this.perspectiveCamera.position.copy(this.model.perspectiveCameraPosition());

    this.model.orthoCameraPosition.onChange("moveAllCameras", function(newval){

        // self.perspectiveCamera.position.copy(newval);
        // self.perspectiveCamera.lookAt(self.model.cameraTarget());

        self.orthographicCamera.position.copy(newval);
        self.orthographicCamera.lookAt(self.model.cameraTarget().toThreejs());

         self.editorView.render();
    });

    this.model.cameraTarget.onChange("changeAllCameras", function(newval){

        self.perspectiveCamera.lookAt(self.model.cameraTarget().toThreejs());

        self.orthographicCamera.lookAt(self.model.cameraTarget().toThreejs());

        self.editorView.render();
    });


    this.model.cameraType.onChange("SwitchViewCamera", function(newval){
        if(newval == 0){
            self.viewCamera = self.perspectiveCamera;
        } else if(newval == 1){
            self.viewCamera = self.orthographicCamera;
        }
        self.editorView.render();
    });


    this.model.orthoZoom.onChange("zoomOrtho", function(val){
        self.orthographicCamera.zoom = val;
        self.orthographicCamera.updateProjectionMatrix();
    }); 

    this.editorView.registerCameraView(this);

};


module.exports = Camera3DView;

Camera3DView.prototype.updateAspectRation = function(width, height){
    var aspect = width / height;
    this.perspectiveCamera.aspect = aspect; 
    this.perspectiveCamera.updateProjectionMatrix();

    this.orthographicCamera.left   = -width  / this.camFac;
    this.orthographicCamera.right  =  width  / this.camFac;
    this.orthographicCamera.top    =  height / this.camFac;
    this.orthographicCamera.bottom = -height / this.camFac;

    this.orthographicCamera.updateProjectionMatrix();

}







